// DEPRECATED: Trial system eliminated
// This component now just renders children without blocking
const TrialBlocker = ({ children, feature }) => {
  // Simply render children - no blocking
  return <>{children}</>;
};

export default TrialBlocker;
